import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "client-role-modal" }
const _hoisted_2 = { class: "client-role-modal__search" }
const _hoisted_3 = {
  key: 0,
  class: "client-role-modal__close"
}
const _hoisted_4 = ["onClick"]

import {
	computed,
	nextTick,
	onMounted,
	ref
} from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { CommonEntityRecord } from "@/models/interfaces/common";
import { searchStore } from "@/store/search";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectClientRoleDropdown',
  props: {
    clientId: {},
    attachedRoles: {},
    showCloseIcon: { type: Boolean }
  },
  emits: ['change', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const store = searchStore()

const isLoading = ref(true)
const filter = ref('')

const roles = computed<CommonEntityRecord[]>(() => store.actualRoles)

const addedIds = computed(() => new Set((props.attachedRoles || []).map(r => r.Id)))

const filteredRoles = computed<CommonEntityRecord[]>(() => {
	const query = filter.value.trim().toLowerCase()
	if (!query) {
		return roles.value
	}

	return roles.value.filter(r => r.Name?.toLowerCase().includes(query))
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const isRoleAdded = (roleId: number) => addedIds.value.has(roleId)

const onToggleRole = (on: boolean, role: CommonEntityRecord) => {
	if (on) {
		store.attachRoleToSelectedClient(props.clientId, { Id: role.Id, Name: role.Name })
	} else {
		store.detachRoleFromSelectedClient(props.clientId, role.Id)
	}
	emit('change')
}

onMounted(async () => {
	try {
		isLoading.value = true
		await store.loadActualRoles()
	} finally {
		isLoading.value = false
	}
	await nextTick(() => $input.value?.focusInput())
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "client-role-modal__search-input",
        placeholder: "Поиск",
        "show-search-button": ""
      }, null, 8, ["modelValue"]),
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              name: "close",
              width: "20px",
              color: "#D2D2D2",
              "hover-color": "#499259",
              cursor: "pointer",
              title: "Закрыть",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "client-role-modal__header" }, [
      _createElementVNode("div", { class: "client-role-modal__header-title" }, " Роли ")
    ], -1)),
    _createElementVNode("div", {
      class: "client-role-modal__body",
      ref_key: "$body",
      ref: $body
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredRoles.value, (role) => {
        return (_openBlock(), _createElementBlock("div", {
          key: role.Id,
          class: "client-role-modal__body-item"
        }, [
          _createVNode(AppCheckbox, {
            style: { height: '16px', marginRight: '8px' },
            value: isRoleAdded(role.Id),
            text: "",
            onInput: (on) => onToggleRole(on, role)
          }, null, 8, ["value", "onInput"]),
          _createElementVNode("div", {
            class: "client-role-modal__body-item-text",
            onClick: ($event: any) => (onToggleRole(!isRoleAdded(role.Id), role))
          }, _toDisplayString(role.Name), 9, _hoisted_4)
        ]))
      }), 128))
    ], 512)
  ]))
}
}

})